/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Person_Create_ValidationInputs */

const fr_person_create_validation = /** @type {(inputs: Person_Create_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le collaborateur n’a pas été créé. Corrigez les champs indiqués, puis réessayez.`)
};

const en_person_create_validation = /** @type {(inputs: Person_Create_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The collaborator was not created. Correct the highlighted fields, then try again.`)
};

/**
* | output |
* | --- |
* | "The collaborator was not created. Correct the highlighted fields, then try again." |
*
* @param {Person_Create_ValidationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const person_create_validation = /** @type {((inputs?: Person_Create_ValidationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Person_Create_ValidationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_person_create_validation(inputs)
	return fr_person_create_validation(inputs)
});